var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChecks = function SvgIconChecks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.207 8.582a1 1 0 0 0-1.414-1.414L5.25 14.71l-3.418-3.418a1 1 0 0 0-1.414 1.414l4.125 4.125a1 1 0 0 0 1.414 0zM23.582 8.582a1 1 0 0 0-1.415-1.414l-7.542 7.543-.803-.803a1 1 0 0 0-1.414 1.415l1.51 1.51a1 1 0 0 0 1.414 0z"
  }))));
};
export default SvgIconChecks;